module.exports = __webpack_public_path__ + "static/media/document-profile.7f3cdc70.jpg";